import React from 'react';
import { Card, Row, Col, Typography, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

type SummaryCardProps = {
    span?: number;
    data: {
        heading: {
            name: string;
            description: string;
            icon: React.ReactNode;
        }, data: {
            name: string;
            value: string | boolean | number;
            status: boolean;
        }[]
    };
};

const SummaryCard: React.FC<SummaryCardProps> = ({ data, span }) => {
    return (
        <Row gutter={[16, 16]} justify="start">
            {data.data.map((item, index) => (
                <Col
                    key={index}
                    span={span || 8}
                >
                    <Space direction='vertical'>
                        <Typography.Title level={5} style={{ marginBottom: 0, lineHeight: 1.2 }}>{item.name}</Typography.Title>
                        {item.status ? (
                            <Space direction='horizontal'>
                                <CheckCircleOutlined style={{ color: 'green' }} />
                                {item.value}
                            </Space>
                        ) : (
                            <Space direction='horizontal'>
                                <CloseCircleOutlined style={{ color: 'red' }} />
                                {item.value}
                            </Space>
                        )}
                    </Space>
                </Col>
            ))}
        </Row>
    );
};

export default SummaryCard;
